export enum ErrorEnum {
  EMAIL_EXISTS = 'A customer with the same email address already exists in an associated website.'
}
